<div class="d-flex flex-column align-items-center text-center mt-3">
  <h2 class="text-center mt-3">340B Recovery Email Subscription</h2>

  @if (!loading) {
    <div>
      @if (error) {
        <div>
          <p class="text-danger text-center mt-3">{{ error }}</p>
        </div>
      }
      @if (!error) {
        <div>
          <p>Your email: <strong>{{ email }}</strong></p>
          @if (unsubscribed) {
            <p>You have been unsubscribed.</p>
          }
          <button (click)="toggleSubscription()" class="btn btn-primary">
            {{ unsubscribed ? 'Resubscribe' : 'Unsubscribe' }}
          </button>
        </div>
      }
    </div>
  } @else {
    <mat-spinner />
  }
</div>

